import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2563eb', // richer blue
      contrastText: '#fff',
    },
    secondary: {
      main: '#06b6d4',
    },
    background: {
      default: '#f6f8fb',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: ['Inter', 'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'].join(','),
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: 'none',
          backgroundImage: 'linear-gradient(180deg, rgba(255,255,255,0.04), rgba(0,0,0,0.02))',
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: 0,
          // subtler semi-transparent gradient so underlying content shows slightly
          background: 'linear-gradient(90deg, rgba(37,99,235,0.80) 0%, rgba(251,146,60,0.80) 100%)',
          backdropFilter: 'saturate(120%) blur(6px)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // make papers flatter and more cohesive with the background
          backgroundColor: 'transparent',
          boxShadow: 'none',
          borderRadius: 4,
        }
      }
    }
  }
});

export default theme;
